import _ from 'lodash';
import { guid } from '@/mixins/guid';

export default function contentSlider() {
  return {
    _id: false,
    type: 'droplet.contentSlider',
    firstUpload: false,
    content: _.times(3, () => ({
      _id: guid.methods.guid(),
      src: `${process.env.S3_ASSETS_URL}mock-images/default-images/img-slider-green.svg`,
      altText: false,
      pageLink: false,
      customLink: false,
      newWindow: false,
    })),
    showAll: false,
    itemLimit: 5,
    effect: 'slide',
    bulletPosition: 'bottom',
    controls: 'show',
    delay: '4',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/content-slider/droplet.schema.js